import { render, staticRenderFns } from "./ExpandirTexto.vue?vue&type=template&id=2f2f403a&scoped=true"
import script from "./ExpandirTexto.vue?vue&type=script&lang=js"
export * from "./ExpandirTexto.vue?vue&type=script&lang=js"
import style0 from "./ExpandirTexto.vue?vue&type=style&index=0&id=2f2f403a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f403a",
  null
  
)

export default component.exports